import { Text } from '@croquiscom-pvt/zds';

import { GeneralProductLandingButton } from '../../../component/option/general-product-landing-button/GeneralProductLandingButton';
import { SelectBoxDropdown } from '../../../component/option/select-box-dropdown/SelectBoxDropdown';
import { SelectBoxItem } from '../../../component/option/select-box-item/SelectBoxItem';
import type { SelectBoxDropdownItem, SelectBoxItemData } from '../../../type/common.type';

interface MainOptionsSectionProps {
  display: boolean;
  display_header_text: boolean;
  display_general_product_landing_link: boolean;
  displayPrice?: boolean;
  displayRestockButton?: boolean;
  dropdown_states: boolean[][];
  option_dropdown_list: SelectBoxDropdownItem[][];
  openAnimation?: boolean;
  actions: {
    setGeneralProductLandingButtonRef: (instance: Element | null) => void;
    handleClickSelectBoxDropdown: (group_index: number, dropdown_index: number, disabled: boolean) => void;
    handleGeneralProductLandingLinkClick: () => void;
  };
}

export const MainOptionsSection = ({
  display,
  display_header_text,
  display_general_product_landing_link,
  displayPrice,
  displayRestockButton,
  dropdown_states,
  option_dropdown_list,
  openAnimation,
  actions,
}: MainOptionsSectionProps) => {
  if (!display) {
    return null;
  }

  return (
    <>
      {option_dropdown_list.map((dropdown, group_index) => {
        return (
          <div key={group_index}>
            {display_header_text && (
              <Text variant='Body_14_SemiBold' v3Color='gray700' style={{ marginBottom: 8 }}>
                상품 {group_index + 1}
              </Text>
            )}
            {dropdown.map(
              ({ selected_option_name, placeholder, data, disabled = false, display = true }, dropdown_index) => (
                <SelectBoxDropdown
                  key={placeholder}
                  open={dropdown_states[group_index][dropdown_index] || false}
                  placeholder={placeholder}
                  label={selected_option_name}
                  openAnimation={openAnimation}
                  display={display}
                  handleClick={() => actions.handleClickSelectBoxDropdown(group_index, dropdown_index, disabled)}
                >
                  {data.map((item: SelectBoxItemData) => (
                    <SelectBoxItem
                      key={item.option.id}
                      {...item}
                      displayPrice={displayPrice}
                      displayRestockButton={displayRestockButton}
                    />
                  ))}
                  {display_general_product_landing_link && (
                    <GeneralProductLandingButton
                      ref={actions.setGeneralProductLandingButtonRef}
                      handleClick={actions.handleGeneralProductLandingLinkClick}
                    />
                  )}
                </SelectBoxDropdown>
              ),
            )}
          </div>
        );
      })}
    </>
  );
};
